import './App.scss';
import React, { Component } from 'react';
import { initializeIcons } from '@uifabric/icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { connect } from 'react-redux';
import history from './history';
import { MsalProvider } from '@azure/msal-react';
import { CustomNavigationClient } from './Utils/NavigationClient';
import Home from './Home';
import { selectAccount, signOut } from './authConfig';
import IdleTimer from 'react-idle-timer';
import SetupAccount from './Containers/SetupAccount/SetupAccount';

library.add(fas, far);

class App extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const navigationClient = new CustomNavigationClient(history);
    initializeIcons();
    selectAccount();
    this.props.pca.setNavigationClient(navigationClient);
  }

  handleOnIdle = (event) => {
    localStorage.setItem('isAutomaticLogout', true);
    localStorage.removeItem('authLang')
    signOut();
  };

  render() {
    let { pca } = this.props;
    return (
      <MsalProvider instance={pca}>
        {window.location.href.includes('setupAccount') ? (
          <div className="setup-container">
            <SetupAccount />
          </div>
        ) : (
          <>
            {/* To Hide the scrollbar when hamburger menu is opened */}
            <div
              className="app-container"
              style={{
                overflowY: `${
                  this.props.generic.isHamburgerVisible ? 'auto' : ''
                }`,
              }}
            >
              <IdleTimer
                timeout={1000 * 60 * 60 * 2}
                onIdle={this.handleOnIdle}
                debounce={250}
                crossTab={{
                  emitOnAllTabs: true,
                  removeTimeout: 1000 * 60,
                }}
              />
              <Home />
            </div>
          </>
        )}
      </MsalProvider>
    );
  }
}

export const mapStateToProps = ({ generic, registration }) => ({
  generic,
  registration,
});

export default connect(mapStateToProps, {})(App);
